import keys from '@debbie/common/dist/cache/keys.js';
import { CaseStatus, convertUserToContact, } from '@debbie/common/dist/cases/index.js';
import { getContactPerson, } from '@debbie/common/dist/customers/index.js';
import { getFoundations, isDocumentFoundation, } from '@debbie/common/dist/documents/index.js';
import { PaymentPlanStatus, getCurrentPaymentPlan, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { Entity, Site } from '@debbie/common/dist/index.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { uniqueBy } from '@debbie/common/dist/util/index.js';
import { NextTaskType, RequirementType, getNextRequirements, getNextTask, } from '@debbie/common/dist/workflows/index.js';
import * as casesAPI from '@debbie/cortex/dist/api/cases.js';
import * as propertiesAPI from '@debbie/cortex/dist/api/properties.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { casesEntity } from '@debbie/cortex/dist/cases/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import { useProperties } from '@debbie/cortex/dist/properties/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useUpdateTypes, useUpdateTypesMap, } from '@debbie/cortex/dist/update-types/index.js';
import { useUpdatesByRefId } from '@debbie/cortex/dist/updates/index.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import Button from './Button.js';
import { getActivePauses } from './CasePauseStatus/index.js';
import { ArrowRight, Edit, ExternalLink } from './Icons/index.js';
import Pause from './Icons/Pause.js';
import Modal from './Modal.js';
import SearchInput from './SearchInput.js';
import Workflow from './Workflows/Workflow.js';
import WorkflowStages from './WorkflowStages.js';
const WorkflowStatus = (props) => {
    const { case: singleCase, customer } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const workflowsLoadable = useWorkflows();
    const workflows = h.hasData(workflowsLoadable) ? workflowsLoadable.data : null;
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const updateTypesLoadable = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable)
        ? updateTypesLoadable.data
        : null;
    const caseVouchers_ = useCaseVouchersByCase(singleCase.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const meRole = useRole();
    const updatesLoadable = useUpdatesByRefId(singleCase?.caseId);
    const caseUpdates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const propertiesLoadable = useProperties(Entity.Case, singleCase?.caseId);
    const properties = h.hasData(propertiesLoadable)
        ? propertiesLoadable.data
        : null;
    const customerPropertiesLoadable = useProperties(Entity.Customer, singleCase.customerId);
    const customerProperties = h.hasData(customerPropertiesLoadable)
        ? customerPropertiesLoadable.data
        : null;
    const creditorPropertiesLoadable = useProperties(Entity.Creditor, singleCase.creditorId);
    const creditorProperties = h.hasData(creditorPropertiesLoadable)
        ? creditorPropertiesLoadable.data
        : null;
    const paymentPlansLoadable = usePaymentPlansByCaseId(singleCase?.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const interactionsLoader = useInteractionsByReference(Entity.Case, props.case.caseId);
    const interactions = h.hasData(interactionsLoader)
        ? interactionsLoader.data
        : null;
    const [modalOpen, setModalOpen] = useState(false);
    const [caseVoucherProperties, setCaseVoucherProperties] = useState(null);
    const [selectedNewWorkflowId, setSelectedNewWorkflowId] = useState(null);
    const [changeWorkflowModalOpen, setChangeWorkflowModalOpen] = useState(false);
    const hasFoundation = documents && !!documents.find((document) => isDocumentFoundation(document));
    const foundationTypes = documents
        ? uniqueBy(getFoundations(documents), (d) => d.type).map((d) => d.type)
        : [];
    const selectedNewWorkflow = workflows &&
        workflows.find((workflow) => workflow.workflowId === selectedNewWorkflowId);
    const workflow = workflows &&
        props.case.workflowId &&
        workflows.find((workflow) => workflow.workflowId === props.case.workflowId);
    const changeWorkflowMutation = useMutation(async () => {
        if (!selectedNewWorkflowId) {
            throw new Error('Please select a workflow');
        }
        if (!workflow) {
            throw new Error('No workflow found');
        }
        await casesAPI.patch(singleCase.caseId, {
            workflowId: selectedNewWorkflowId,
        });
    }, {
        onSuccess: () => {
            q.invalidate(keys.write.modify(casesEntity, singleCase.caseId));
            setChangeWorkflowModalOpen(false);
            setSelectedNewWorkflowId(null);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.workflow);
        },
    });
    const loadCaseVoucherProperties = async (_caseVouchers) => {
        try {
            const caseVoucherProperties = await propertiesAPI.getMultiple({
                ref: Entity.CaseVoucher,
                refIds: _caseVouchers.map((cv) => cv.caseVoucherId),
            });
            setCaseVoucherProperties(Object.values(caseVoucherProperties).reduce((a, b) => a.concat(b), []));
        }
        catch (error) {
            console.error('Failed to load case voucher properties:', error);
        }
    };
    useEffect(() => {
        // TODO: Use cortex queries for this
        if (workflow && caseUpdates && caseVouchers) {
            if (getNextRequirements(workflow, caseUpdates)
                .map((r) => r.type)
                .includes(RequirementType.Property) &&
                caseVouchers.length > 0) {
                // Load case voucher properties
                loadCaseVoucherProperties(caseVouchers);
            }
            else {
                setCaseVoucherProperties([]);
            }
        }
    }, [workflow, caseUpdates, caseVouchers]);
    const nextTask = workflow &&
        caseUpdates &&
        props.case &&
        caseVouchers &&
        documents &&
        interactions &&
        properties &&
        customerProperties !== null &&
        creditorProperties !== null &&
        Array.isArray(caseVoucherProperties) &&
        typeof hasFoundation === 'boolean'
        ? getNextTask(workflow, {
            contact: convertUserToContact(getContactPerson(customer, props.case)),
            isCompany: props.case.isCompany,
            caseStatus: props.case.status,
            endReasonId: props.case.endReasonId,
            updates: caseUpdates,
            caseVouchers: caseVouchers,
            caseGroupId: props.case.caseGroup?.id || null,
            caseId: props.case.caseId,
            creditorId: props.case.creditorId,
            hasFoundation,
            foundationTypes,
            customerTags: customer.tags,
            caseTags: props.case.tags,
            interactions: interactions,
            properties: properties.concat(caseVoucherProperties, customerProperties, creditorProperties),
        })
        : null;
    const paymentPlan = getCurrentPaymentPlan(paymentPlans);
    const activePaymentPlan = paymentPlan?.status === PaymentPlanStatus.ACTIVE &&
        singleCase.status === CaseStatus.VERIFIED;
    const workflowPaused = (singleCase &&
        caseUpdates &&
        meRole &&
        getActivePauses(caseUpdates, updateTypesMap, meRole).some((activePause) => activePause.futurePause === null && activePause.updateType.pausing)) ||
        activePaymentPlan;
    const updateTypeId = nextTask &&
        (nextTask.type === NextTaskType.NormalTask ||
            nextTask.type === NextTaskType.StartingPointTask) &&
        nextTask.task?.updateTypeId;
    const updateType = updateTypeId && updateTypesMap[updateTypeId];
    if (!workflow) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(WorkflowTitle, { onClick: () => setModalOpen(!modalOpen) },
            React.createElement("div", null,
                React.createElement("h3", { style: { display: 'inline-block', verticalAlign: 'middle' } }, workflow && workflow.title),
                caseUpdates && workflow && singleCase && (React.createElement(WorkflowStages, { workflow: workflow, updates: caseUpdates }))),
            singleCase &&
                (() => {
                    const nextTaskTitle = updateType &&
                        (lang.updateTypes[updateType.updateTypeId] || updateType.label);
                    const dueDate = nextTask &&
                        (nextTask.type === NextTaskType.NormalTask ||
                            nextTask.type === NextTaskType.StartingPointTask) &&
                        nextTask.date;
                    const nextTaskAt = dueDate
                        ? moment.duration(moment(dueDate).diff(moment())).asDays()
                        : 0;
                    return (React.createElement("p", { "data-tooltip-content": singleCase.status === CaseStatus.ENDED
                            ? undefined
                            : singleCase.status === CaseStatus.PENDING
                                ? lang.workflows.workflowWillStartWhenCaseIsVerified
                                : activePaymentPlan
                                    ? lang.workflows.pausedBecauseOfPaymentPlan
                                    : workflowPaused
                                        ? lang.workflows.caseIsPaused
                                        : nextTaskAt <= 0
                                            ? lang.workflows.nextTaskASAP
                                            : `${lang.cases.dueDateIsIn} ${nextTaskAt.toFixed()} ${lang.cases.days} (${dueDate
                                                ? moment(dueDate).format('DD.MM.YY H:mm')
                                                : ''})`, "data-tooltip-id": "tooltip-default" }, activePaymentPlan ? (lang.paymentPlans.paymentPlan) : (React.createElement(React.Fragment, null, (nextTaskTitle ||
                        nextTask?.type === NextTaskType.ManualTask) && (React.createElement(React.Fragment, null,
                        workflowPaused && (React.createElement(Pause, { style: {
                                height: '1.8em',
                                width: '1.8em',
                                margin: '-0.1em 0.3em -0.5em 0em',
                            } })),
                        nextTask.pastUpdate ? (React.createElement(React.Fragment, null,
                            lang.updateTypes[nextTask.pastUpdate.updateTypeId] || nextTask.pastUpdate.label,
                            ' ',
                            singleCase.status !== CaseStatus.ENDED && (React.createElement(ArrowRight, { style: {
                                    margin: '0.2em 0.5em -0.2em',
                                } })),
                            ' ')) : null,
                        singleCase.status !== CaseStatus.ENDED
                            ? nextTask?.type === NextTaskType.ManualTask
                                ? lang.workflows.manualSelection
                                : nextTaskTitle
                            : null))))));
                })()),
        modalOpen && (React.createElement(Modal, { header: React.createElement(React.Fragment, null,
                workflow.title,
                ' ',
                meRole && isAdmin(meRole) && site === Site.Caseworker && (React.createElement(ExternalLink, { style: {
                        float: 'inherit',
                        margin: '0.1em 0 -0.1em',
                        cursor: 'pointer',
                    }, onClick: () => c.redirect.redirect(`/workflows/${workflow.workflowId}`) })),
                site === Site.Caseworker && (React.createElement(Edit, { style: {
                        float: 'inherit',
                        margin: '0.1em 0 -0.1em',
                        cursor: 'pointer',
                        marginLeft: '0.5em',
                    }, onClick: () => setChangeWorkflowModalOpen(!changeWorkflowModalOpen) }))), onToggle: () => setModalOpen(!modalOpen), maxWidth: "1600px" }, updateTypes &&
            singleCase &&
            caseUpdates &&
            caseVouchers &&
            customer &&
            interactions &&
            properties &&
            customerProperties !== null &&
            creditorProperties !== null &&
            Array.isArray(caseVoucherProperties) &&
            typeof hasFoundation === 'boolean' && (React.createElement(StatusWorkflow, { updateTypes: updateTypes, workflow: workflow, caseContext: {
                singleCase,
                updates: caseUpdates,
                caseVouchers: caseVouchers,
                customer,
                hasFoundation,
                foundationTypes,
                interactions,
                properties: properties.concat(caseVoucherProperties, customerProperties, creditorProperties),
            }, closeModal: () => setModalOpen(false) })))),
        changeWorkflowModalOpen && (React.createElement(Modal, { header: lang.workflows.changeWorkflowOnCase, onToggle: () => setChangeWorkflowModalOpen(!changeWorkflowModalOpen), maxWidth: "400px" },
            React.createElement(SearchInput, { forceOpen: true, placeholder: lang.workflows.workflows, onSelect: (id) => setSelectedNewWorkflowId(id), searchAll: (q) => {
                    return (workflows || [])
                        .filter((workflow) => JSON.stringify(workflow)
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) !== -1 || q.length === 0)
                        .map((workflow) => ({
                        key: workflow.workflowId,
                        heading: workflow.title,
                        subheading: workflow.description,
                        returnData: workflow.workflowId,
                    }));
                }, static: selectedNewWorkflow?.title, onRemoveStatic: () => setSelectedNewWorkflowId(null) }),
            React.createElement(Button, { loading: changeWorkflowMutation.isLoading, disabled: !selectedNewWorkflowId, onClick: () => changeWorkflowMutation.mutate(), block: true }, lang.inputs.save)))));
};
export default WorkflowStatus;
const StatusWorkflow = styled(Workflow) `
  height: calc(100vh - ${THEME.NAV_TOP_HEIGHT + 120}px);
`;
const WorkflowTitle = styled.div `
  display: inline-block;
  font-size: 0.75em;
  font-weight: 900;
  cursor: pointer;

  h3 {
    margin: 0;
  }

  p {
    margin: 0.2em 0;
    font-size: 0.8em;
  }
`;
//# sourceMappingURL=WorkflowStatus.js.map